/*
 * Copyright (c) 2023. World Wide Generation Ltd
 */

import { useMemo } from 'react';
import { ScopeQuestionGroup } from '@g17eco/types/survey';
import { getSurveyQuestionProgress } from '@utils/survey';
import SurveyProgress, { AnimationVariant } from '@components/survey-progress';

interface AssessmentProgressProps {
  surveyGroups: ScopeQuestionGroup[];
}

export const AssessmentProgress = ({ surveyGroups }: AssessmentProgressProps) => {

  const progressStats = useMemo(() => getSurveyQuestionProgress(surveyGroups), [surveyGroups]);

  return (
    <div className='flex-fill'>
      <div>
        <SurveyProgress {...progressStats} animationVariant={AnimationVariant.Animated} />
      </div>
      <div className='text-right text-ThemeTextPlaceholder'>
        {progressStats.completed} / {progressStats.count}
      </div>
    </div>
  )
}
